//GRAVITY FORMS - MATERIAL DSIGN - ADD FOCUS TO LABEL

jQuery(function($) {



  function activateForm($form) {
    $('input, textarea, select', $form).focusin(function(){
      $(this).parent().siblings('label').addClass('focused');
    });

    $('input, textarea, select', $form).focusout(function(){
      var input = $(this);
      if( input.val().length === 0 ){
        input.parent().siblings('label').removeClass('focused');
      }
    });
  }

  $('.gform_wrapper').each(function() {
    activateForm($(this))
  })

  //on ajax submission
  $('#gform_ajax_frame_1, #gform_ajax_frame_2, #gform_ajax_frame_3').on( 'load', function(){
    var $formWrapper = $(this).parent();
    setTimeout(function() {
      activateForm($formWrapper)

      $('form input, form textarea, form select', $formWrapper).each(function(){
        if( $(this).val().length != 0 ){
          $(this).parent().siblings('label').addClass('focused');
        }
      });
    }, 300)

  });
})
